import { ApiError } from '@/helper/api-error'
import concat from 'lodash/concat'

export class ValidatorError extends ApiError {

  public validationErrors: {
    [p: string]: string[],
  }

  constructor(message: string, status: number, code: string, validationErrors: { [p: string]: string[] }) {
    super(message, status, code)
    this.validationErrors = validationErrors
  }

  public formatValidatorErrors(): string[] {
    const objectProperties = Object.keys(this.validationErrors)

    let errorsList: string[] = []
    objectProperties.forEach((propertyKey: string) => {
      errorsList = concat(errorsList, this.validationErrors[propertyKey])
    })
    return errorsList
  }
}
